// @flow @jsx h

// import { Video } from '@nrk/dh-feature-components'
import { Component, h } from 'preact'
import style from './index.css'
import Scrubber from './Scrubber'
import TogglePlayButton from './TogglePlayButton'
import MuteButton from './MuteButton'
import ResponsiveVideo from './ResponsiveVideo'

import type { Props, State } from './types'

class VideoPlayer extends Component<Props, State> {
  elm: HTMLDivElement
  video: ResponsiveVideo

  constructor () {
    super()

    this.state = {
      paused: true,
      caption: null,
      muted: true,
      time: 0,
      duration: 0,
      userPaused: false
    }
  }

  handleCaptionCueEnter = (cue: any) => {
    this.setState({ caption: cue.text })
  }

  handleCaptionCueExit = () => {
    this.setState({ caption: null })
  }

  handleDurationChange = (event: Object) => {
    this.setState({ duration: event.target.duration })
  }

  handleTimeUpdate = (event: Object) => {
    this.setState({ time: event.target.currentTime })
  }

  handlePositionUpdate = (position: number) => {
    this.video.updateTime(position * this.state.duration)
  }

  handleTogglePlay = () => {
    const paused = !this.state.paused
    this.setState({ paused, userPaused: paused })
    if (!paused) {
      this.video.play()
    }
  }

  handlePlay = () => {
    const { onPlay } = this.props

    this.setState({ paused: false })

    if (onPlay) {
      onPlay()
    }
  }

  handlePause = () => {
    const { onPause } = this.props

    this.setState({ paused: true })

    if (onPause) {
      onPause()
    }
  }

  handleEnded = () => {
    this.setState({ paused: true })
  }

  render () {
    const {
      captions,
      horizontal,
      vertical,
      muted,
      onToggleMute,
      viewport
    } = this.props
    const { caption, duration, time, paused, userPaused } = this.state
    const playing = !userPaused && this.props.playing

    return (
      <div
        ref={elm => (this.elm = elm)}
        className={style.videoPlayer}
        style={this.props.style}
      >
        <div className={style.videoPlayer__videoWrapper}>
          <ResponsiveVideo
            ref={video => (this.video = video)}
            preload='auto'
            muted={muted}
            playing={playing}
            captions={captions}
            horizontal={horizontal}
            vertical={vertical}
            onCaptionCueEnter={this.handleCaptionCueEnter}
            onCaptionCueExit={this.handleCaptionCueExit}
            onDurationChange={this.handleDurationChange}
            onPlay={this.handlePlay}
            onPause={this.handlePause}
            onEnded={this.handleEnded}
            onTimeUpdate={this.handleTimeUpdate}
            viewport={viewport}
          />
          <TogglePlayButton
            className={style.videoPlayer__togglePlayButton}
            onClick={this.handleTogglePlay}
            paused={paused}
          />
          <Scrubber
            time={time}
            duration={duration}
            onPositionUpdate={this.handlePositionUpdate}
          />
          <MuteButton
            className={style.videoPlayer__muteButton}
            onClick={onToggleMute}
            muted={muted}
          />
          {caption && (
            <div className={style.videoPlayer__captionContainer}>
              <div
                className={style.videoPlayer__caption}
                dangerouslySetInnerHTML={{ __html: caption }}
              />
            </div>
          )}
        </div>
      </div>
    )
  }
}

export default VideoPlayer
